import React from "react";

interface WorkItemProps {
  company: string;
  position: string;
  tasks: string[];
  location: string;
  onClose: any;
}

const WorkItem: React.FC<WorkItemProps> = ({
  company,
  position,
  tasks,
  location,
  onClose,
}) => (
  <div className="work-item">
    <div className="bg-white">
      <a
        className="close-button d-none d-md-block "
        onClick={onClose}
        href={`#workitem`}
      >
        <i className="fa fa-3x fa-times"></i>
      </a>
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-secondary text-uppercase mb-0">{company} </h2>
            <h5>{position}</h5>
            <hr className="star-dark mb-5" />
            <h5>Responsibilities</h5>
            <hr className="mb-5" />
            <div className="mb-5">
              <ul style={{ listStyle: "none" }}>
                {tasks.map((task: string, id: number) => (
                  <li key={id}>{task}</li>
                ))}
              </ul>
              {location}
            </div>
            <div
              className="btn btn-primary btn-lg rounded-pill portfolio-modal-dismiss"
              onClick={onClose}
            >
              <i className="fa fa-close"></i>
              Close {company}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WorkItem;
